import React from 'react';

import Router from '../router/router';

const Vivaz = () => {
  return <Router />;
};

export default Vivaz;
